import React from 'react';
import { useTranslation } from 'react-i18next';
import Paragraph from '@features/_common/components/Paragraph/Paragraph';
import BasicTable from '@features/_common/components/BasicTable/BasicTable';
import style from './Cookies.module.scss';

export default function CookiesPage() {
  const { t } = useTranslation('cookies\\Cookies');

  const technicalTableHeaders = [
    t('cookiesTechnicalCol1'),
    t('cookiesTechnicalCol2'),
    t('cookiesTechnicalCol3'),
    t('cookiesTechnicalCol4'),
  ];

  const technicalTableRows = [
    [
      t('cookiesTechnicalRow1Col1'),
      t('cookiesTechnicalRow1Col2'),
      t('cookiesTechnicalRow1Col3'),
      t('cookiesTechnicalRow1Col4'),
    ],
    [
      t('cookiesTechnicalRow2Col1'),
      t('cookiesTechnicalRow2Col2'),
      t('cookiesTechnicalRow2Col3'),
      t('cookiesTechnicalRow2Col4'),
    ],
    [
      t('cookiesTechnicalRow3Col1'),
      t('cookiesTechnicalRow3Col2'),
      t('cookiesTechnicalRow3Col3'),
      t('cookiesTechnicalRow3Col4'),
    ],
    [
      t('cookiesTechnicalRow4Col1'),
      t('cookiesTechnicalRow4Col2'),
      t('cookiesTechnicalRow4Col3'),
      t('cookiesTechnicalRow4Col4'),
    ],
    [
      t('cookiesTechnicalRow5Col1'),
      t('cookiesTechnicalRow5Col2'),
      t('cookiesTechnicalRow5Col3'),
      t('cookiesTechnicalRow5Col4'),
    ],
    [
      t('cookiesTechnicalRow6Col1'),
      t('cookiesTechnicalRow6Col2'),
      t('cookiesTechnicalRow6Col3'),
      t('cookiesTechnicalRow6Col4'),
    ],
    [
      t('cookiesTechnicalRow7Col1'),
      t('cookiesTechnicalRow7Col2'),
      t('cookiesTechnicalRow7Col3'),
      t('cookiesTechnicalRow7Col4'),
    ],
  ];

  const analyticsTableHeaders = [
    t('cookiesAnalyticsCol1'),
    t('cookiesAnalyticsCol2'),
    t('cookiesAnalyticsCol3'),
    t('cookiesAnalyticsCol4'),
  ];

  const analyticsTableRows = [
    [
      t('cookiesAnalyticsRow1Col1'),
      t('cookiesAnalyticsRow1Col2'),
      t('cookiesAnalyticsRow1Col3'),
      t('cookiesAnalyticsRow1Col4'),
    ],
    [
      t('cookiesAnalyticsRow2Col1'),
      t('cookiesAnalyticsRow2Col2'),
      t('cookiesAnalyticsRow2Col3'),
      t('cookiesAnalyticsRow2Col4'),
    ],
    [
      t('cookiesAnalyticsRow3Col1'),
      t('cookiesAnalyticsRow3Col2'),
      t('cookiesAnalyticsRow3Col3'),
      t('cookiesAnalyticsRow3Col4'),
    ],
  ];

  return (
    <main className={style.container}>
      <h1 className={style.title}>{t('cookiesTitle')}</h1>
      <Paragraph title={t('cookiesWhatAre')} text={t('cookiesWhatAreP1')} />
      <Paragraph text={t('cookiesWhatAreP2')} />
      <Paragraph text={t('cookiesWhatAreP3')} />
      <Paragraph text={t('cookiesWhatAreP4')} />

      <Paragraph title={t('cookiesUsed')} text={t('cookiesUsedP1')} />
      <Paragraph text={t('cookiesUsedP2')} />

      <Paragraph title={t('cookiesNoUsed')} text={t('cookiesNoUsedP1')} />

      <Paragraph title={t('cookiesInfo')} text={t('cookiesInfoP1')} />
      <Paragraph text={t('cookiesInfoP2')} />

      <Paragraph title={t('cookiesReject')} text={t('cookiesRejectP1')} />
      <Paragraph text={t('cookiesRejectP2')} />
      <Paragraph text={t('cookiesRejectP3')} />

      <Paragraph title={t('cookiesDelete')} text={t('cookiesDeleteP1')} />
      <Paragraph text={t('cookiesDeleteP2')} />

      <Paragraph title={t('cookiesType')} text={t('cookiesTypeP1')} />

      <h3 className={style.subTitle}>{t('cookiesTypeEntity')}</h3>
      <Paragraph
        title={t('cookiesTypeEntityUl1')}
        text={t('cookiesTypeEntityUl1P')}
      />
      <Paragraph
        title={t('cookiesTypeEntityUl2')}
        text={t('cookiesTypeEntityUl2P')}
      />
      <Paragraph text={t('cookiesTypeEntityP')} />

      <h3 className={style.subTitle}>{t('cookiesTypePurpose')}</h3>
      <Paragraph
        title={t('cookiesTypePurposeUl1')}
        text={t('cookiesTypePurposeUl1P')}
      />
      <Paragraph
        title={t('cookiesTypePurposeUl2')}
        text={t('cookiesTypePurposeUl2P')}
      />
      <Paragraph
        title={t('cookiesTypePurposeUl3')}
        text={t('cookiesTypePurposeUl3P')}
      />
      <Paragraph
        title={t('cookiesTypePurposeUl4')}
        text={t('cookiesTypePurposeUl4P')}
      />

      <h3 className={style.subTitle}>{t('cookiesTypeTime')}</h3>
      <Paragraph
        title={t('cookiesTypeTimeUl1')}
        text={t('cookiesTypeTimeUl1P1')}
      />
      <Paragraph text={t('cookiesTypeTimeUl1P2')} />
      <Paragraph
        title={t('cookiesTypeTimeUl2')}
        text={t('cookiesTypeTimeUl2P')}
      />

      <h3 className={style.subTitle}>{t('cookiesDetail')}</h3>

      <BasicTable
        title={t('cookiesTechnical')}
        headers={technicalTableHeaders}
        rows={technicalTableRows}
      />

      <BasicTable
        title={t('cookiesAnalytics')}
        headers={analyticsTableHeaders}
        rows={analyticsTableRows}
      />
    </main>
  );
}
